import Toggle from '@resources/js/ui/Toggle'


export default class Modal extends Toggle {
	constructor(target, { trigger = '', toggleClass, selectors, hideOnBackdrop = true, lockScroll = true } = {}) {
		super(trigger, { target, toggleClass })

		this.selectors = {
			close: '.js-popup-close',
			content: '.js-popup-content',
			...selectors
		}

		this.callbacks = {
			show: () => this.show(),
			hide: () => this.hide(),
			clickBackdropHandler: (e) => this._clickBackdropHandler(e)
		}

		this.lockScroll = lockScroll

		this.initCloseBtn()

		if(hideOnBackdrop) {
			this.initHideOnClickOutSide()
		}
	}

	initCloseBtn() {
		this._closeTriggers = [...this.target.querySelectorAll(this.selectors.close)]
		this._closeTriggers.forEach(trigger => trigger.addEventListener('click', this.callbacks.hide))
	}

	initHideOnClickOutSide() {
		this.target.addEventListener('click', this.callbacks.clickBackdropHandler)
	}

	_clickBackdropHandler(e) {
		if(e.target.matches(this.selectors.content) || e.target.closest(this.selectors.content))
			return

		this.hide()
	}

	show() {
		if(this.lockScroll) document.body.style.overflow = 'hidden'
		super.show()
		this.emit('show')
	}

	hide() {
		if(this.lockScroll) document.body.style.overflow = 'auto'
		super.hide()
		this.emit('hide')
	}

	destroy() {
		super.destroy()
		this._closeTriggers.forEach(trigger => trigger.removeEventListener('click', this.callbacks.hide))
		this.target.removeEventListener('click', this.callbacks.clickBackdropHandler)
	}
}
